<financial-statement-filter [company]="company" (emmitSearch)="onSearch($event)"></financial-statement-filter>
<div class="metrics-container grid-cols-2 grid-cols-4" *ngIf="hasSalesHistoryCompany()">
  <div class="metric-card first-card">
    <div>
      <p class="label">Produtos Vendidos</p>
      <p class="value">{{ salesHistoryCompany.getSalesHistorySummary().getProductSoldCount() }}</p>
    </div>
    <mat-icon class="icon" aria-hidden="false">inventory_2</mat-icon>
  </div>
  <div class="metric-card second-card">
    <div>
      <p class="label">Valores Gerados</p>
      <p class="value">{{ salesHistoryCompany.getSalesHistorySummary().getSalesValueableCount() | currencyPbmPipe }}</p>
    </div>
    <mat-icon class="icon" aria-hidden="false">attach_money</mat-icon>
  </div>
  <div class="metric-card third-card">
    <div>
      <p class="label">Subsídio Praticado</p>
      <p class="value">{{ salesHistoryCompany.getSalesHistorySummary().getSalesSubsidyValueCount() | currencyPbmPipe }}</p>
    </div>
    <mat-icon class="icon" aria-hidden="false">trending_down</mat-icon>
  </div>
  <div class="metric-card fourth-card">
    <div>
      <p class="label">Desconto em folha</p>
      <p class="value">{{ salesHistoryCompany.getSalesHistorySummary().getPaymentrollValueCount() | currencyPbmPipe }}</p>
    </div>
    <mat-icon class="icon" aria-hidden="false">receipt</mat-icon>
  </div>
</div>
<div *ngIf="hasSalesHistoryCompany()" class="filters-container">
  <div class="container-title">
    <h3>Detalhes do Extrato</h3>
    <button class="export-btn" mat-flat-button (click)="exportReportToPDF()" matTooltip="Exportar PDF">
      <mat-icon aria-hidden="false">picture_as_pdf</mat-icon>
      <span>Exportar PDF</span>
    </button>
  </div>
  <form [formGroup]="filterForm" class="form-container grid-cols-2 grid-cols-4">
    <div fxLayout="column" fxLayoutAlign="center start">
      <span class="title">Data inicial</span>
      <mat-form-field appearance="outline">
        <input
          formControlName="startDate"
          matInput
          type="text"
          placeholder="Data inicial"
          (change)="onFilterChange()"
          [textMask]="{ mask: dataMask, guide: true, keepCharPositions: true }" />
      </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="center start">
      <span class="title">Data final</span>
      <mat-form-field appearance="outline">
        <input
          formControlName="endDate"
          matInput
          type="text"
          placeholder="Data final"
          (change)="onFilterChange()"
          [textMask]="{ mask: dataMask, guide: true, keepCharPositions: true }" />
      </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="center start">
      <span class="title">Por Fabricante</span>
      <mat-form-field appearance="outline">
        <input formControlName="productManufacturer" matInput type="text" placeholder="Por Fabricante" (change)="onFilterChange()" />
      </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="center start">
      <span class="title">Por Tipo de Produto</span>
      <mat-form-field appearance="outline">
        <mat-select formControlName="productType" (selectionChange)="onFilterChange()">
          <mat-option value="">Todos</mat-option>
          <mat-option *ngFor="let type of productTypes" [value]="type.getValue()">{{ type.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef>Medicamento/Produto</th>
        <td mat-cell *matCellDef="let element" matTooltip="{{ element.getProductName() }}" class="no-wrap">
          {{ element.getProductName() }}
        </td>
      </ng-container>

      <ng-container matColumnDef="soldItemCount">
        <th mat-header-cell *matHeaderCellDef>Quantidade</th>
        <td mat-cell *matCellDef="let element">{{ element.getSoldItemCount() }}</td>
      </ng-container>

      <ng-container matColumnDef="stateName">
        <th mat-header-cell *matHeaderCellDef>Região</th>
        <td mat-cell *matCellDef="let element">{{ element.getStateName() }}</td>
      </ng-container>

      <ng-container matColumnDef="networkName">
        <th mat-header-cell *matHeaderCellDef>Rede</th>
        <td mat-cell *matCellDef="let element" class="no-wrap">{{ element.getNetworkName() }}</td>
      </ng-container>

      <ng-container matColumnDef="soldValueCount">
        <th mat-header-cell *matHeaderCellDef>Valor Gerado</th>
        <td mat-cell *matCellDef="let element" matTooltip="{{ element.getSoldValueCount().toFixed(2) | currencyPbmPipe }}">
          {{ element.getSoldValueCount().toFixed(2) | currencyPbmPipe }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div fxLayoutAlign="end end">
    <button mat-button class="load-more-btn" *ngIf="hasSalesHistoryCompanyItem()" (click)="searchMore()">
      Carregar mais registros
    </button>
  </div>
</div>
<div class="beneficiary-cards" *ngIf="!hasSalesHistoryCompany()"></div>
